import { render } from "./EstadisticasView.vue?vue&type=template&id=4ceaf926"
import script from "./EstadisticasView.vue?vue&type=script&lang=js"
export * from "./EstadisticasView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__